export const constants = {
    FETCH_REQUESTS: 'FETCH_CALENDAR_REQUESTS',
    SET_WORKER_CHECKED: 'SET_WORKER_CHECKED',
};
